// extracted by mini-css-extract-plugin
module.exports = {"root":"Control_root__i_4kC","label":"Control_label__1PKgR","error":"Control_error__AbL8C"};